import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {userForConversationNoticeType} from "./__graphql-types__/index.ts";

export const USER_FOR_CONVERSATION_NOTICE_QUERY: GqlOperation<
    userForConversationNoticeType["response"],
    userForConversationNoticeType["variables"]
> = gqlOp(gql`
    query userForConversationNotice {
        user {
            id
            hasParents
            hasCoach
        }
    }
`);
